import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import * as Msdyn365 from '@msdyn365-commerce/core';

export class AppInsights {
    private static _instance: AppInsights | null = null;
    private _applicationInsights: ApplicationInsights;

    public static getInstance(context: Msdyn365.ICoreContext<{ [x: string]: any }>): ApplicationInsights {
        if (AppInsights._instance === null) {
            AppInsights._instance = new AppInsights(context);
        }

        return AppInsights._instance._applicationInsights;
    }

    private constructor(context: Msdyn365.ICoreContext<{ [x: string]: any }>) {
        const connectionString = context.app.config.applicationInsightsConnectionString;

        this._applicationInsights = new ApplicationInsights({
            config: {
                connectionString
            }
        });

        this._applicationInsights.loadAppInsights();
    }
}
